export default __webpack_public_path__ + "static/Fig 15 - Cumulative Map-f1caa2e243e25da06991772d0a908b19.pdf";